const LangVerifyGoldCardAddress = {
	"verifyGoldCardAddress.copy._message": [
		"Please confirm your mailing list to recieve gold card.",
		"សូម​បញ្ជាក់​​អាសយដ្ឋាន​របស់​លោក​អ្នក​ ដើម្បី​ឲ្យ​យើង​ខ្ញុំ​ផ្ញើ​កាត​សមាជិក​មាស​ជូន​ ។",
	],
	"verifyGoldCardAddress.message._updateAddress": [
		"Your address has been updated.",
		"អាសយដ្ឋាន​របស់​លោក​អ្នក ​ត្រូវ​បាន​បញ្ចូល​​",
	],
	"verifyGoldCardAddress._title": [
		"Verify Mailing Address",
		"បញ្ជាក់​អាសយដ្ឋាន​សម្រាប់​ផ្ញើ​ឥវ៉ាន់",
	],
}

export default LangVerifyGoldCardAddress



// WEBPACK FOOTER //
// ./src/resources/pages/LangVerifyGoldCardAddress.js